import CommonState from './CommonState'

export function getCommonState(code, list) {
  for (var common of list) {
    if (common.code === code) {
      return common
    }
  }
  return null
}

export const CODE_NAME = 'CreditHistoryAction'

export const SPECIAL_APPROVAL = new CommonState(4, '特批', 'special approval')
export const LOCK = new CommonState(5, '锁单', 'lock')
export const UNLOCK = new CommonState(10, '解锁', 'unlock')
export const CANCEL_SPECIAL_APPROVAL = new CommonState(11, '取消特批', 'Cancel special approval')

// 信控日志
export const LOG_ACTION = new Set([UNLOCK, LOCK, SPECIAL_APPROVAL, CANCEL_SPECIAL_APPROVAL])
